<!-- TEMPLATE CONTRACT: Ui Assignment Selector Component owns the visible Angular template structure for src/app/shared/ui/ui-assignment-selector/ui-assignment-selector.component.html. -->
<div class="ui-assignment-selector">
  <ui-select
    [label]="label()"
    [required]="required()"
    [multiple]="!single()"
    [value]="values()[0] || ''"
    [values]="values()"
    [options]="options()"
    [error]="error()"
    [hint]="hint()"
    [loadMoreOnScroll]="loadMoreOnScroll()"
    [loadingMoreOptions]="loadingMoreOptions()"
    [hasMoreOptions]="hasMoreOptions()"
    (valueChange)="onValueChange($event)"
    (valuesChange)="onValuesChange($event)"
    (loadMoreOptions)="onLoadMoreOptions()"
  ></ui-select>


  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (selectedRows().length=== 0) {
    <ui-empty-state
          [title]="emptyStateTitle() | uiLabelTranslate"
          [description]="emptyStateDescription() | uiLabelTranslate"
        ></ui-empty-state>
  }
  <!-- Alternate branch documents the fallback UI state. -->
  @else {

  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (badgeRules(); as resolvedBadgeRules) {
    <!-- Table/list section for scanning records and opening details. -->
    <ui-table
      [columns]="columns()"
      [data]="selectedRows()"
      [emptyMessage]="emptyMessage()"
      [showToolbar]="false"
      [showPagination]="showPagination()"
      [defaultPageSize]="defaultPageSize()"
      [showActionsColumn]="rowActions().length > 0"
      [rowActions]="rowActions()"
      [badgeRules]="resolvedBadgeRules"
      (actionClick)="onActionClick($event)"
    ></ui-table>
  } @else {
    <!-- Table/list section for scanning records and opening details. -->
    <ui-table
      [columns]="columns()"
      [data]="selectedRows()"
      [emptyMessage]="emptyMessage()"
      [showToolbar]="false"
      [showPagination]="showPagination()"
      [defaultPageSize]="defaultPageSize()"
      [showActionsColumn]="rowActions().length > 0"
      [rowActions]="rowActions()"
      (actionClick)="onActionClick($event)"
    ></ui-table>
  }
}
</div>
